module.exports = __webpack_public_path__ + "static/media/29BDOS4.e9e99905.jpg";